import React from 'react';
import AcaoListPageContainer from './AcaoListPageContainer';

export class AcaoListPage extends React.Component{
    
    render(){
      return (
        <AcaoListPageContainer {...this.props}/>
      )
    }
}


